// External libraries
import React from 'react';
import { useStoreState } from '@/store';
// @ts-expect-error untyped-import
import { FieldError, FloatingLabelInput } from '@checkout/react-components';

import { features, getContent } from '@/lib';
import { appStore } from '@/store';
import type { AddressType } from '@/types';
import { InlineFieldsContainer } from './StyledComponents';
import type { FormAddressTypes } from '@/store/models/form/types';

interface SplitAddressLine1Props {
  id: string;
  name: string;
  addressType: AddressType;
  value: string;
}

const StreetName = ({
  id,
  addressType,
  name,
  ...rest
}: SplitAddressLine1Props) => {
  const { value, isValid } = useStoreState(state => {
    // @ts-expect-error Fix form state
    return state.form[`${addressType}Address`].streetName;
  });
  const { displayError } = useStoreState(state => {
    // @ts-expect-error Fix form state
    return state.form[`${addressType}Address`].line1;
  });

  const theme = features.get('rebrandFormFieldsTheme');

  return (
    <FloatingLabelInput
      {...rest}
      ariaDescribedBy={!isValid && `${addressType}-line1-error`}
      displayError={false}
      hasError={displayError && !isValid}
      id={`${addressType}StreetName`}
      label={getContent('fieldLabels.streetName')}
      name={`${addressType}StreetName`}
      required={true}
      theme={theme}
      value={value}
    />
  );
};

const HouseNumber = ({
  id,
  addressType,
  name,
  ...rest
}: SplitAddressLine1Props) => {
  const { value, isValid } = useStoreState(state => {
    // @ts-expect-error Fix form state
    return state.form[`${addressType}Address`].houseNumber;
  });
  const { displayError } = useStoreState(state => {
    // @ts-expect-error Fix form state
    return state.form[`${addressType}Address`].line1;
  });

  return (
    <FloatingLabelInput
      {...rest}
      ariaDescribedBy={!isValid && `${addressType}-line1-error`}
      displayError={false}
      hasError={displayError && !isValid}
      id={`${addressType}HouseNumber`}
      label={getContent('fieldLabels.streetNumber')}
      name={`${addressType}HouseNumber`}
      required={true}
      value={value}
    />
  );
};

const getValidityInfo = (type: AddressType) => {
  const { form } = appStore.getState();
  const addressType: FormAddressTypes = `${type}Address`;
  const line1 = form[addressType]?.line1;
  const isValid = line1?.isValid;
  const displayError = line1?.displayError;

  return { displayError, isValid };
};

const SplitAddressLine1 = (props: SplitAddressLine1Props): JSX.Element => {
  const { displayError, isValid } = getValidityInfo(props.addressType);

  return (
    <>
      <InlineFieldsContainer>
        <StreetName {...props} />
        <HouseNumber {...props} />
      </InlineFieldsContainer>
      {displayError && !isValid && (
        <FieldError id={`${props.addressType}-line1-error`}>
          {getContent('fieldErrors.valueMissing')}
        </FieldError>
      )}
    </>
  );
};

export { SplitAddressLine1 };
